module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/personal-care-man-banner@2x_dbb895.png";